/* Lounelle — lightweight PDP shipping bootstrap.
 * The historical inline PDP timer remains the primary runtime. The complete
 * fallback engine is loaded only when a timer is still uninitialised.
 */
(function () {
  'use strict';

  if (window.__LounelleShippingBootstrapReady) return;
  window.__LounelleShippingBootstrapReady = true;

  var TIMER_SELECTOR = '[data-shipping-timer]';
  var MONEY_ROOT_SELECTOR = '[data-lounelle-shipping-root]';
  var corePromise = null;

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function coreUrl() {
    if (window.theme && window.theme.assets && window.theme.assets.base) {
      return window.theme.assets.base + 'lounelle-shipping-timer-core.js';
    }

    var current = document.currentScript;
    if (!current || !current.src) return '';

    try {
      var url = new URL(current.src, window.location.href);
      url.pathname = url.pathname.replace(/lounelle-shipping-timer\.js$/, 'lounelle-shipping-timer-core.js');
      url.search = '';
      return url.href;
    } catch (_) {
      return '';
    }
  }

  function loadCore() {
    if (window.__LounelleShippingCoreLoaded) return Promise.resolve();
    if (corePromise) return corePromise;

    var src = coreUrl();
    if (!src) return Promise.reject(new Error('Missing shipping core URL'));

    corePromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = function () {
        window.__LounelleShippingCoreLoaded = true;
        resolve();
      };
      script.onerror = function () {
        corePromise = null;
        reject(new Error('Shipping core failed to load'));
      };
      document.head.appendChild(script);
    });

    return corePromise;
  }

  function formatMoneyRoot(root) {
    if (!root || root.dataset.moneyReady === 'true') return;

    var locale = [root.dataset.language, root.dataset.country].filter(Boolean).join('-') || undefined;
    var currency = String(root.dataset.currency || 'EUR').trim().toUpperCase();
    var formatter;

    try {
      formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
    } catch (_) {
      try {
        formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
      } catch (_) {
        return;
      }
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-lounelle-money]'), function (node) {
      var amount = Number.parseFloat(node.dataset.amount || '');
      if (!Number.isFinite(amount)) return;
      var template = node.dataset.template || '[AMOUNT]';
      node.textContent = template.replaceAll('[AMOUNT]', formatter.format(amount));
    });

    root.dataset.moneyReady = 'true';
  }

  function collect(scope, selector) {
    var container = scope || document;
    var nodes = [];
    if (container.matches && container.matches(selector)) nodes.push(container);
    if (container.querySelectorAll) {
      Array.prototype.push.apply(nodes, container.querySelectorAll(selector));
    }
    return nodes;
  }

  function inspect(scope) {
    collect(scope, MONEY_ROOT_SELECTOR).forEach(formatMoneyRoot);

    var needsCore = false;
    collect(scope, TIMER_SELECTOR).forEach(function (timer) {
      if (timer.dataset.localTimerReady) return;

      var primary = timer.querySelector('.lounelle-timer-primary');
      if (primary && normalize(primary.textContent)) {
        timer.dataset.localTimerReady = 'legacy';
      } else {
        needsCore = true;
      }
    });

    if (needsCore) loadCore().catch(function () {});
  }

  function boot() {
    inspect(document);

    document.addEventListener('theme:product-info:loaded', function (event) {
      var scope = event.target.closest && event.target.closest('product-info');
      inspect(scope || event.target);
    });

    document.addEventListener('shopify:section:load', function (event) {
      inspect(event.target);
    });
  }

  /* Deferred scripts run after parsing but before DOMContentLoaded. Waiting for
   * DOMContentLoaded lets the historical inline timer initialise first. */
  if (document.readyState === 'complete') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  }
})();
